// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import "../assets/Loan/ViewLoanCollectionReceipt.css"; // Create this file
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// const ViewLoanCollectionReceipt = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const receiptRef = useRef(null);
//   const thermalReceiptRef=useRef(null)
//   const data = location.state?.collectionReceipt;
//   console.log("cusotmer", data);

//   const { profile } = useSelector((state) => state.userProfile);
//   const dispatch = useDispatch();
//   console.log("profile", profile);

//   const [company, setCompany] = useState(null);

//   // fetch profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   const fetchCompany = async () => {
//     try {
//       const res = await fetch(
//         `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
//       );
//       const data = await res.json();
//       if (res.ok && data) {
//         if (data.logo) {
//           data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//         }
//         if (data.qrCodeImage) {
//           data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
//         }
//         setCompany(data);
//       }
//     } catch (err) {
//       console.error("Error fetching company:", err);
//     }
//   };

//   useEffect(() => {
//     fetchCompany();
//   }, [profile?.superAdminId]);

//   const handlePrint = async () => {
//     if (!receiptRef.current) return;

//     const canvas = await html2canvas(receiptRef.current, {
//       scale: 2,
//       useCORS: true,
//       backgroundColor: "#fff",
//     });

//     const imgData = canvas.toDataURL("image/jpeg", 0.8);
//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "mm",
//       format: "a4", // Professional receipts usually A4 or A5
//     });

//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

//     pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

//     // Stable Print logic
//     const blobUrl = pdf.output("bloburl");
//     const iframe = document.createElement("iframe");
//     iframe.style.display = "none";
//     iframe.src = blobUrl;
//     document.body.appendChild(iframe);

//     iframe.onload = () => {
//       iframe.contentWindow.focus();
//       iframe.contentWindow.print();
//       window.addEventListener(
//         "focus",
//         () => {
//           setTimeout(() => {
//             if (document.body.contains(iframe))
//               document.body.removeChild(iframe);
//           }, 500);
//         },
//         { once: true },
//       );
//     };
//   };


//    const handlePrintThermalSlip = async () => {
//     if (!thermalReceiptRef.current) return;

//     const { jsPDF } = await import("jspdf");
//     const html2canvas = (await import("html2canvas")).default;

//     // 1️⃣ Render slip to canvas
//     const canvas = await html2canvas(thermalReceiptRef.current, {
//       scale: 3,
//       backgroundColor: "#ffffff",
//     });
//     const imgData = canvas.toDataURL("image/png");

//     // 2️⃣ Prepare PDF (thermal size)
//     const pdfWidth = 58; // mm
//     const imgWidth = pdfWidth;
//     const imgHeight = (canvas.height * pdfWidth) / canvas.width;

//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "mm",
//       format: [pdfWidth, imgHeight],
//     });
//     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

//     // 3️⃣ Try to open print window
//     try {
//       const printWindow = window.open("", "_blank", "width=1000,height=600");

//       printWindow.document.write(`
//         <html>
//           <head>
//             <title>Print Slip</title>
//             <style>
//               @page { size: 58mm auto; margin:0; }
//               body { margin:0; padding:0; text-align:center; }
//               img { width:58mm; max-width:58mm; }
//             </style>
//           </head>
//           <body>
//             <img src="${imgData}" />
//           </body>
//         </html>
//       `);

//       printWindow.document.close();

//       // Wait for print window to load
//       printWindow.onload = () => {
//         printWindow.focus();
//         printWindow.print();
//         // Optional: close after printing
//         setTimeout(() => printWindow.close(), 500);
//       };
//     } catch (err) {
//       // 4️⃣ Fallback → Download PDF
//       pdf.save(`LoanSlip_${data.customerName || "Customer"}.pdf`);
//     }
//   };

//   if (!data) {
//     return <div className="p-10 text-center">Receipt Data Not Found</div>;
//   }

//   return (
//     <div className="receipt-viewer-container">
//       {/* Action Buttons */}
//       <div className="receipt-actions receipt-no-print">
//         <button onClick={() => navigate(-1)} className="receipt-back-btn">
//           Back
//         </button>
//         <button onClick={handlePrint} className="btn-print-receipt">
//           Print Receipt
//         </button>
//         <button onClick={()=>{
//             handlePrintThermalSlip() 
//         }
//         }className="btn-thermal-print-receipt">
//           Thermal Print Receipt
//         </button>
//       </div>

//       {/* Printable Receipt Design */}
//       <div className="receipt-paper" ref={receiptRef}>
//         <div className="receipt-header-section">
//           <div className="receipt-header-company-section">
//             <div className="receipt-company-details">
//               <img src={company?.logoUrl} alt="logo" className="receipt-logo" />
//               <div className="receipt-header-company-info">
//                 <h1>{company?.name || "N/A"}</h1>
//                 <p className="address">
//                   <b>Address: </b>
//                   {company?.address || "N/A"}
//                 </p>
//                 <p className="contact">
//                   <b>Phone:</b> {company?.contact || "N/A"} | <b>Email:</b>{" "}
//                   {company?.email || "N/A"}
//                 </p>
//                 <p className="cin">
//                   <b>CIN:</b> {company?.cin || "N/A"}
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="receipt-title-box">
//             <h2>COLLECTION RECEIPT</h2>
//             <p>
//               Receipt No: #{data.id || "905"} | Date:{" "}
//               {new Date(Date.now()).toLocaleDateString(
//                 "en-GB",
//               )||data.createdAt }
//             </p>
//           </div>
//         </div>

//         {/* Sections */}
//         <div className="receipt-section">
//           <h3 className="receipt-section-title">Collection DETAILS</h3>
//           <div className="receipt-details-wrapper">
//             <div className="receipt-grid-item">
//               <span>Customer Name:</span> <strong>{data.customerName || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Loan Account Number:</span>{" "}
//               <strong>{data.loanNumber || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Emi Number:</span>{" "}
//               <strong>{data.emiNumber || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Emi Amount:</span>{" "}
//               <strong>{"₹"+data.emiAmount || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Principal Amount:</span>{" "}
//               <strong>{"₹"+data.principalComponent || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Interest Rate:</span>{" "}
//               <strong>{"₹"+data.interestComponent || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Due Date:</span>{" "}
//               <strong>
//                 {new Date(data.dueDate).toLocaleDateString("en-GB") || "N/A"}
//               </strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Paid Date:</span>{" "}
//               <strong>
//                 {new Date(data.paymentDate).toLocaleDateString("en-GB") ||
//                   "N/A"}
//               </strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Status:</span>{" "}
//               <strong>{data.status.toUpperCase() || "N/A"}</strong>
//             </div>
//           </div>
//         </div>

//         <table className="receipt-outstanding-table">
//           <tr className="receipt-outstanding-row">
//             <td>Outstanding Amount</td>
//             <td>
//               ₹{" "}
//               {Number(data.outstanding).toLocaleString("en-IN", {
//                 minimumFractionDigits: 2,
//               })}
//             </td>
//           </tr>
//         </table>


//         <div className="receipt-footer-signs">
//           <div className="receipt-sign-box">
//             <div className="receipt-sign-line"></div>
//             <p>Authorized Signatory</p>
//           </div>
//           <div className="receipt-sign-box">
//             <div className="receipt-sign-line"></div>
//             <p>Customer Signature</p>
//           </div>
//         </div>

//         <p className="receipt-system-gen-text">
//           This is a system-generated slip and does not require a signature.
//           <br />
//           For any queries, please contact us during business hours.
//         </p>
//       </div>

      

// {/* Thermal print design */}
//       <div className="thermal-slip-wrapper">
//   <div ref={thermalReceiptRef} className="thermal-slip">
    
//     {/* COMPANY INFO */}
//     <div className="thermal-company">
//       <div className="thermal-company-name">
//         {company ? company.name : "--"}
//       </div>
//       <div className="thermal-company-text">
//         <b>Address:</b> {company ? company.address : "--"}
//       </div>
//       <div className="thermal-company-text">
//         <b>Phone:</b> {company ? company.contact : "--"} | <b>Email:</b> {company ? company.email : "--"}
//       </div>
//       <div className="thermal-company-text">
//         <b>CIN:</b> {company ? company.cin : "--"}
//       </div>
      
//     </div>

//     {/* TITLE */}
//     <div className="thermal-title">
//       Collection Receipt
//     </div>

//     <div className="thermal-divider"></div>

//     {/* DETAILS */}
//     <div className="thermal-row">
//       <b>Customer Name:</b> {data?.customerName || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>Loan Account Number:</b> {data?.loanNumber || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>EMI Number:</b> {data?.emiNumber || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>EMI Amount:</b> {"₹"+data?.emiAmount || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>Principal:</b>{"₹"+data?.principalComponent || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>Interest Rate:</b> {"₹"+data?.interestComponent || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>Due Date:</b> {new Date(data.dueDate).toLocaleDateString("en-GB") || "N/A"}
//     </div>
//     <div className="thermal-row">
//       <b>Paid Date:</b> {new Date(data.paymentDate).toLocaleDateString("en-GB") ||
//                   "N/A"}
//     </div>
//     <div className="thermal-row">
//       <b>Status:</b> {data?.status || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>Outstanding Amount:</b> ₹{" "}{data?.outstanding || "--"}
//     </div>

//     <div className="thermal-divider"></div>

//     {/* FOOTER */}
//     <div className="thermal-footer">
//       <div>Thank you for your payment!</div>
//       <div>
//        Computer Generated Receipt
//       </div>
//     </div>
//   </div>
// </div>
//     </div>
//   );
// };

// export default ViewLoanCollectionReceipt;




import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../assets/Loan/ViewLoanCollectionReceipt.css"; // Create this file
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

const ViewLoanCollectionReceipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const singleReceipt = location.state?.collectionReceipt;
  const bulkReceipts = location.state?.receipts;

  const receiptList = React.useMemo(() => {
    if (Array.isArray(bulkReceipts) && bulkReceipts.length > 0) {
      return bulkReceipts;
    }
    if (singleReceipt && typeof singleReceipt === "object") {
      return [singleReceipt];
    }
    return [];
  }, [bulkReceipts, singleReceipt]);

  const receiptRef = useRef(null);
  const thermalReceiptRef = useRef(null);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  console.log("profile", profile);

  const [company, setCompany] = useState(null);

  // fetch profile
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
      );
      const data = await res.json();
      if (res.ok && data) {
        if (data.logo) {
          data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
        }
        if (data.qrCodeImage) {
          data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
        }
        setCompany(data);
      }
    } catch (err) {
      console.error("Error fetching company:", err);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, [profile?.superAdminId]);

  const handlePrint = async () => {
    if (!receiptList.length) return;

    const pdf = new jsPDF("p", "mm", "a4");

    for (let i = 0; i < receiptList.length; i++) {
      const container = document.getElementById(`receipt-${i}`);
      if (!container) continue;

      if (i > 0) pdf.addPage();

      const canvas = await html2canvas(container, {
        scale: 1.5,
        useCORS: true,
        backgroundColor: "#fff",
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.9);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);
    }

    // ✅ Stable print (no blank pages)
    const blobUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = blobUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      window.addEventListener(
        "focus",
        () => {
          setTimeout(() => {
            if (document.body.contains(iframe)) {
              document.body.removeChild(iframe);
            }
          }, 500);
        },
        { once: true },
      );
    };
  };

const handlePrintThermalSlip = async () => {
  if (!receiptList || receiptList.length === 0) return;

  try {
    const html2canvas = (await import("html2canvas")).default;

    // 🔹 Create hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    doc.open();
    doc.write(`
      <html>
        <head>
          <style>
            @page {
              size: 58mm auto;
              margin: 0;
            }
            body {
              margin: 0;
              padding: 0;
              display: flex;
              flex-direction: column;
              align-items: center;   /* ✅ center horizontally */
              justify-content: flex-start;
            }
            img {
              width: 58mm;
              max-width: 58mm;
              margin: 0 auto;        /* ✅ extra safety */
              display: block;
            }
            .page-break {
              page-break-after: always;
              height: 2mm;
            }
          </style>
        </head>
        <body></body>
      </html>
    `);
    doc.close();

    // 🔹 Capture & append slips
    for (let i = 0; i < receiptList.length; i++) {
      const ref = document.getElementById(`thermal-${i}`);
      if (!ref) continue;

      const canvas = await html2canvas(ref, {
        scale: 3,
        backgroundColor: "#fff",
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");

      const img = doc.createElement("img");
      img.src = imgData;

      await new Promise((res) => (img.onload = res));
      doc.body.appendChild(img);

      if (i !== receiptList.length - 1) {
        const divider = doc.createElement("div");
        divider.className = "page-break";
        doc.body.appendChild(divider);
      }
    }

    // 🔹 Print & cleanup
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    }, 300);

  } catch (err) {
    console.error("Thermal printing failed", err);
    alert("Thermal print failed");
  }
};



  if (!receiptList.length) {
    return <div className="p-10 text-center">Receipt Data Not Found</div>;
  }

  return (
    <div className="receipt-viewer-container">
      {/* Action Buttons */}
      <div className="receipt-actions receipt-no-print">
        <button onClick={() => navigate(-1)} className="receipt-back-btn">
          Back
        </button>
        <button onClick={handlePrint} className="btn-print-receipt">
          Print Receipt
        </button>
        <button
          onClick={() => {
            handlePrintThermalSlip();
          }}
          className="btn-thermal-print-receipt"
        >
          Thermal Print Receipt
        </button>
      </div>

      {/* Printable Receipt Design */}
      {receiptList.map((data, index) => (
        <div
          key={data.id}
          id={`receipt-${index}`}
          style={{ pageBreakAfter: "always" }}
          className="receipt-paper"
          ref={receiptRef}
        >
          <div className="receipt-header-section">
            <div className="receipt-header-company-section">
              <div className="receipt-company-details">
                <img
                  src={company?.logoUrl}
                  alt="logo"
                  className="receipt-logo"
                />
                <div className="receipt-header-company-info">
                  <h1>{company?.name || "N/A"}</h1>
                  <p className="address">
                    <b>Address: </b>
                    {company?.address || "N/A"}
                  </p>
                  <p className="contact">
                    <b>Phone:</b> {company?.contact || "N/A"} | <b>Email:</b>{" "}
                    {company?.email || "N/A"}
                  </p>
                  <p className="cin">
                    <b>CIN:</b> {company?.cin || "N/A"}
                  </p>
                </div>
              </div>
            </div>

            <div className="receipt-title-box">
              <h2>COLLECTION RECEIPT</h2>
              <p>
                Receipt No: #{data.id || "905"} | Date:{" "}
                {new Date(Date.now()).toLocaleDateString("en-GB") ||
                  data.createdAt}
              </p>
            </div>
          </div>

          {/* Sections */}
          <div className="receipt-section">
            <h3 className="receipt-section-title">Collection DETAILS</h3>
            <div className="receipt-details-wrapper">
              <div className="receipt-grid-item">
                <span>Customer Name:</span>{" "}
                <strong>{data.customerName || "N/A"}</strong>
              </div>
              <div className="receipt-grid-item">
                <span>Loan Account Number:</span>{" "}
                <strong>{data.loanNumber || "N/A"}</strong>
              </div>
              <div className="receipt-grid-item">
                <span>Emi Number:</span>{" "}
                <strong>{data.emiNumber || "N/A"}</strong>
              </div>
              <div className="receipt-grid-item">
                <span>Emi Amount:</span>{" "}
                <strong>{"₹" + data.emiAmount || "N/A"}</strong>
              </div>
              <div className="receipt-grid-item">
                <span>Principal Amount:</span>{" "}
                <strong>{"₹" + data.principalComponent || "N/A"}</strong>
              </div>
              <div className="receipt-grid-item">
                <span>Interest Amount:</span>{" "}
                <strong>{"₹" + data.interestComponent || "N/A"}</strong>
              </div>
              <div className="receipt-grid-item">
                <span>Due Date:</span>{" "}
                <strong>
                  {new Date(data.dueDate).toLocaleDateString("en-GB") || "N/A"}
                </strong>
              </div>
              <div className="receipt-grid-item">
                <span>Paid Date:</span>{" "}
                <strong>
                  {new Date(data.paymentDate).toLocaleDateString("en-GB") ||
                    "N/A"}
                </strong>
              </div>
              <div className="receipt-grid-item">
                <span>Status:</span>{" "}
                <strong>{data.status.toUpperCase() || "N/A"}</strong>
              </div>
            </div>
          </div>

          <table className="receipt-outstanding-table">
            <tr className="receipt-outstanding-row">
              <td>Outstanding Amount</td>
              <td>
                ₹{" "}
                {Number(data.outstanding).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </td>
            </tr>
          </table>

          <div className="receipt-footer-signs">
            <div className="receipt-sign-box">
              <div className="receipt-sign-line"></div>
              <p>Authorized Signatory</p>
            </div>
            <div className="receipt-sign-box">
              <div className="receipt-sign-line"></div>
              <p>Customer Signature</p>
            </div>
          </div>

          <p className="receipt-system-gen-text">
            This is a system-generated slip and does not require a signature.
            <br />
            For any queries, please contact us during business hours.
          </p>
        </div>
      ))}

      {/* Thermal print design */}
      {receiptList.map((data, index) => (
        <div
          key={index}
          id={`thermal-${index}`}
          className="thermal-slip-wrapper"
        >
          <div ref={thermalReceiptRef} className="thermal-slip">
            {/* COMPANY INFO */}
            <div className="thermal-company">
              <div className="thermal-company-name">
                {company ? company.name : "--"}
              </div>
              <div className="thermal-company-text">
                <b>Address:</b> {company ? company.address : "--"}
              </div>
              <div className="thermal-company-text">
                <b>Phone:</b> {company ? company.contact : "--"} | <b>Email:</b>{" "}
                {company ? company.email : "--"}
              </div>
              <div className="thermal-company-text">
                <b>CIN:</b> {company ? company.cin : "--"}
              </div>
            </div>

            {/* TITLE */}
            <div className="thermal-title">Collection Receipt</div>

            <div className="thermal-divider"></div>

            {/* DETAILS */}
            <div className="thermal-row">
              <b>Customer Name:</b> {data?.customerName || "--"}
            </div>
            <div className="thermal-row">
              <b>Loan Account Number:</b> {data?.loanNumber || "--"}
            </div>
            <div className="thermal-row">
              <b>EMI Number:</b> {data?.emiNumber || "--"}
            </div>
            <div className="thermal-row">
              <b>EMI Amount:</b> {"₹" + data?.emiAmount || "--"}
            </div>
            <div className="thermal-row">
              <b>Principal:</b>
              {"₹" + data?.principalComponent || "--"}
            </div>
            <div className="thermal-row">
              <b>Interest Amount:</b> {"₹" + data?.interestComponent || "--"}
            </div>
            <div className="thermal-row">
              <b>Due Date:</b>{" "}
              {new Date(data.dueDate).toLocaleDateString("en-GB") || "N/A"}
            </div>
            <div className="thermal-row">
              <b>Paid Date:</b>{" "}
              {new Date(data.paymentDate).toLocaleDateString("en-GB") || "N/A"}
            </div>
            <div className="thermal-row">
              <b>Status:</b> {data?.status || "--"}
            </div>
            <div className="thermal-row">
              <b>Outstanding Amount:</b> ₹ {data?.outstanding || "--"}
            </div>

            <div className="thermal-divider"></div>

            {/* FOOTER */}
            <div className="thermal-footer">
              <div>Thank you for your payment!</div>
              <div>Computer Generated Receipt</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ViewLoanCollectionReceipt;
